import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-nav-organizations',
    templateUrl: './nav-organizations.component.html',
    styleUrls: ['./nav-organizations.component.scss'],
})
export class NavOrganizationsComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
